import { API_LCL_URL, FTL_WEB_APP_API, WEBAPP_PRICING_API } from 'app/commons/constants/env.const'
import apiClient from 'app/commons/helpers/api/api'
import { INoteCustomer } from 'app/interface/IBooking'
import store from 'app/store'

import api from '../commons/helpers/api/index'

const bookingApi = {
  getVersionBooking: (id: string) => api.get(`/v1/lcl/booking/${id}/version`),
  getBookingDetails: (id: string, bookingVersion: string) => api.get(`/${bookingVersion}/lcl/booking/${id}/detail`),
  getRoutes: (params: any) =>
    apiClient.get(`/api/v1/routes`, {
      params,
      headers: {
        'x-use-case': 'eta',
      },
    }),
  changeStageToGoingToPickup: (id: string) => api.patch(`/v1/lcl/booking/${id}/going-to-pickup`),
  getInfoNoneBooker: (id: string, bookingVersion: string) =>
    api.get(`/${bookingVersion}/lcl/booking/noauth/${id}/detail`),
  saveBooking: (bookingId: string, isBookmark: boolean) =>
    api.patch(`/v1/lcl/booking/${bookingId}/bookmark`, '', {
      isBookmark: isBookmark,
    }),
  cancelToEditBooking: (bookingId: string) => api.patch(`/v1/lcl/booking/${bookingId}/cancel-to-edit`),
  cancelBooking: (id: any, cancelReasonId?: string) =>
    api.patch(`/v1/lcl/booking/${id}/cancel`, '', {
      cancelReasonId,
    }),
  createBooking: (data: any) => api.post(`/v1/lcl/booking`, '', data),
  patchEditItemsBooking: (data: any) => api.patch(`/v1/lcl/booking/items`, '', data),
  updateLocationsDraftBooking: (data: any) => api.patch(`/v1/lcl/booking/locations`, '', data),
  updateNoteCustomer: (id: string, data: INoteCustomer) =>
    apiClient.patch(`/v1/lcl/booking/${id}/location/notes`, data),
  confirmBooking: (data: any) => api.patch(`/v1/lcl/booking/confirmation`, '', data),
  updateInfoBooking: (data: any) => api.patch(`/v1/lcl/booking`, '', data),
  editBooking: (data: any, id: string) => api.patch(`/v1/lcl/booking/${id}/edit`, '', data),

  getInfoReimbursement: (bookingId: string) =>
    api.get(`${FTL_WEB_APP_API}/api/v3/bookings/${bookingId}/reimbursement_info`),
  confirmReimbursement: (bookingId: string, dataSend: any) => {
    const { configuration } = store.getState()
    const url = configuration.data?.enable_booking_dispatching_service
      ? `/v1/bookings/${bookingId}/confirm_reimbursements`
      : `${FTL_WEB_APP_API}/api/v3/bookings/${bookingId}/reimbursements/confirm`
    return api.put(url, '', dataSend)
  },

  getVessel: (data: any) => api.post(`/v1/lcl/schedule/vessel`, '', data),
  getCheckLocationDestination: (queryString: any) => api.get(`/v1/lcl/schedule/location/verify?${queryString}`),
  getPickupTime: (data: any) => api.post(`/v1/lcl/schedule/pickup-time`, '', data),

  getGeocode: (latlng: any) => api.get(`/api/v1/geocode/reverse`, latlng),
  getLatLngFormAddress: (data: any) => api.get(`/api/v1/geocode`, data),

  getLocationRecently: () => api.get(`/api/v1/locations`),
  postSaveLocationRecently: (data: any) => api.post(`/api/v1/locations`, '', data),
  getCheckLocations: (param: any) => api.get(`${FTL_WEB_APP_API}/cargo_api/v1/locations/check_locations?${param}`),
  getCheckLocationPickup: (queryString: any) => api.get(`${FTL_WEB_APP_API}/lcl_api/v1/check_locations?${queryString}`),

  // Check locations (OSA)
  getVehicleInfo: (queryString: any) => api.get(`${FTL_WEB_APP_API}/lcl_api/v1/extra_infos?${queryString}`),
  calculatePricing: (data: any) => api.post(`${WEBAPP_PRICING_API}/api/v1/pricing`, '', data),
  getListContact: (data: any) => api.get(`${API_LCL_URL}/v1/catalog/contacts/search`, data),
}

export default bookingApi
